import packageInfo from '../../package.json';
import { Environment } from './environment.interface';

export const INTERNAL_ENV_PARAMS: Environment = {
    production: false,
    apiUrl: 'https://api.wecdev.com',
    allowedDomains: 'api.wecdev.com',
    signalRUrl: 'https://api.wecdev.com',
    version: packageInfo.version,
};
